"use client";

import { useEffect, Suspense } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import Script from "next/script";

function RouteViews() {
  const path = usePathname(), query = useSearchParams();
  useEffect(() => {
    window.dispatchEvent(new Event("site:page"));
  }, [path, query]);
  return null;
}

/** One count per visible navigation, including client-side pagination. */
export default function Traffic() {
  return <>
    <Script src="/traffic-v2.js" strategy="afterInteractive" />
    <Suspense fallback={null}><RouteViews /></Suspense>
  </>;
}
